"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const contexts_1 = require("../../contexts");
const utils_1 = require("../../utils");
/**
 * 🔀 Navigation
 *
 * This is a stub router. Intended to be replaced by an external router plugin.
 */
class Navigation extends react_1.default.PureComponent {
    render() {
        const BB = this.context;
        const routes = (0, utils_1.resolveThunk)(this.props.navigator.routes, BB) || [];
        const route = routes[0];
        if (!route) {
            return null;
        }
        const Screen = typeof route.screen === 'string' ? BB.Components.resolve(route.screen) : route.screen;
        let navigator = null;
        if (route.navigator) {
            navigator = <Navigation navigator={route.navigator}/>;
        }
        let node = navigator;
        if (route.screen) {
            const Component = Screen;
            node = <Component key={route.name}>{navigator}</Component>;
        }
        return (<contexts_1.NavigationContext.Provider value={contexts_1.StubNavigationActionsObject}>
				{node}
			</contexts_1.NavigationContext.Provider>);
    }
}
exports.Navigation = Navigation;
Navigation.contextType = contexts_1.BlueBaseContext;
